export default __webpack_public_path__ + "static/media/home_gsa.802a6ef5.png";